<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <title-bar></title-bar>
            <v-card-title class="primary--text text-h6 pl-4 font-weight-bold"
              >SUBMIT APPLICATION</v-card-title
            >
            <v-card-text>
              PLEASE READ CAREFULLY, INITIAL EACH PARAGRAPH AND SIGN BELOW. ONLY
              APPLICATIONS THAT ARE SIGNED AND DATED ARE CONSIDERED VALID.
            </v-card-text>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card class="mb-3">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="10" order-md="2">
                        I hereby certify that I have not knowingly withheld any
                        information that might adversely affect my chances for
                        employment and that the answers given by me are true and
                        correct to the best of my knowledge. I further certify
                        that I, the undersigned applicant, have personally
                        completed (or used a preparer to complete) this
                        application. I understand that any omission or
                        misstatement of material fact on this application or on
                        any document used to secure employment shall be grounds
                        rejection of this application or for immediate discharge
                        if I am employed, regardless of the time elapsed before
                        discovery.
                      </v-col>
                      <v-col cols="12" md="2" order-md="1">
                        <v-text-field
                          id="cert"
                          v-model="q.certify"
                          :rules="requiredRules"
                          label="Initial Here"
                          prepend-inner-icon="mdi-fountain-pen-tip"
                          filled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-3">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="10" order-md="2">
                        I understand that nothing contained in the application,
                        or conveyed during any interview which may be granted or
                        during my employment, if hired, is intended to create an
                        employment contract between me and the Company. In
                        addition, I understand and agree that if I am employed,
                        my employment is for no definite or determinable period
                        and may be terminated at any time, with or without prior
                        notice, at the option of either myself or the Company,
                        and that no promises or representations contrary to the
                        foregoing are binding on the Company unless made in
                        writing and signed by me and the Company’s designated
                        representative.
                      </v-col>
                      <v-col cols="12" md="2" order-md="1">
                        <v-text-field
                          v-model="q.contract"
                          :rules="requiredRules"
                          label="Initial Here"
                          prepend-inner-icon="mdi-fountain-pen-tip"
                          filled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-3">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="10" order-md="2">
                        I understand that in compliance with federal law, if
                        hired, I will be required to verify identity and
                        eligibility to work in the United States and to complete
                        the required I-9 form.
                      </v-col>
                      <v-col cols="12" md="2" order-md="1">
                        <v-text-field
                          v-model="q.compliance"
                          :rules="requiredRules"
                          label="Initial Here"
                          prepend-inner-icon="mdi-fountain-pen-tip"
                          filled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-3">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="10" order-md="2">
                        By initialing here, I acknowledge that I have received
                        the Dutch Bros Coffee Employee
                        <router-link
                          :to="{ name: 'Privacy Rights Notice' }"
                          target="_blank"
                        >
                          Privacy Rights Notice
                        </router-link>
                        &nbsp; and I accept the terms of this Privacy Rights
                        Notice.
                      </v-col>
                      <v-col cols="12" md="2" order-md="1">
                        <v-text-field
                          v-model="q.privacy"
                          :rules="requiredRules"
                          label="Initial Here"
                          prepend-inner-icon="mdi-fountain-pen-tip"
                          filled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card class="mb-3">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="signature"
                          :rules="requiredRules"
                          label="Type your full name to sign"
                          prepend-inner-icon="mdi-fountain-pen-tip"
                          required
                          filled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="date"
                          :rules="dateRules"
                          label="Today's Date"
                          prepend-inner-icon="mdi-calendar"
                          placeholder="MM/DD/YYYY"
                          v-mask="'##/##/####'"
                          required
                          filled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="secondary" @click="previous">Previous</v-btn>
              <v-btn class="mr-5" color="primary" @click="formSubmit"
                >Let's Do This!</v-btn
              >
            </v-card-actions>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" top right>
      {{ error_message }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import TitleBar from "../components/TitleBar";
import FooterBar from "../components/Footer";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RC_SITE_KEY });

export default {
  components: { TitleBar, FooterBar },

  computed: {
    work: {
      get() {
        return this.$store.state.work;
      },
      set(value) {
        this.$store.commit("setWork", { work: value });
      },
    },
    q: {
      get() {
        return this.$store.state.q;
      },
      set(value) {
        this.$store.commit("setQ", { q: value });
      },
    },
    signature: {
      get() {
        return this.$store.state.signature;
      },
      set(value) {
        this.$store.commit("setSignature", { signature: value });
      },
    },
    date: {
      get() {
        return this.$store.state.date;
      },
      set(value) {
        this.$store.commit("setDate", { date: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },

  data: () => ({
    valid: false,
    loading: false,
    snackbar: false,
    error_message:
      "An error occurred when submitting your application. Please verify your contact information is entered correctly.",
    requiredRules: [(v) => !!v || "This field is required"],
    dateRules: [
      (v) => !!v || "Date is required",
      (v) =>
        /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d?$/.test(
          v
        ) || "Date must be valid",
    ],
    multiLine: true,
  }),
  props: {
    source: String,
  },

  methods: {
    async formSubmit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;
        const token = await this.getRecaptchaToken("applicationForm");
        let currentObj = this;
        axios
          .post(
            process.env.VUE_APP_APPLICATION_API + `?rc=${token}`,
            this.$store.state
          )
          .then((response) => {
            this.loading = false;
            currentObj.output = response.data;
            console.log("go!");
            this.$router.push({ name: "Confirmation" });
          })
          .catch((error) => {
            this.loading = false;
            this.snackbar = true;
            console.log("There was an error:", error.response);
            currentObj.output = error;
          });
      }
    },
    async getRecaptchaToken(action) {
      await this.$recaptchaLoaded();
      return await this.$recaptcha(action);
    },
    previous(e) {
      e.preventDefault();
      this.$router.push({ name: "P5" });
    },
  },
};
</script>
